import { HTMLAttributes, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';

type PageLayoutContentProps = HTMLAttributes<HTMLDivElement>;

const PageLayoutContent = (props: PageLayoutContentProps) => {
  const { className, children } = props;
  const [containerMinHeight, setContainerMinHeight] = useState(0);

  /**
   * effects
   */
  useEffect(() => {
    calculateContainerMinHeight();
  }, []);

  /**
   * methods
   */
  const calculateContainerMinHeight = () => {
    const headerEl = document.getElementById('jove-website-page-layout-header');
    const footerEl = document.getElementById('jove-website-page-layout-footer');
    setContainerMinHeight(
      window.innerHeight -
        (headerEl?.clientHeight || 0) -
        (footerEl?.clientHeight || 0)
    );
  };

  return (
    <Box
      className={clsx('flex flex-col', className)}
      style={{
        minHeight: `${containerMinHeight}px`,
      }}
    >
      {children}
    </Box>
  );
};

export default PageLayoutContent;
